import { getEndDate, getEventTimeZoneId, getScheduleTbdMessage, getShowTimeZone, getStartDate, isDateTbd, isEndDateHidden, isScheduled, isStarted, } from '@wix/wix-events-commons-statics';
import { getDurationInHours, getMomentDate, now } from './date';
import { formatDates, getFullDate, getShortDate, getShortDateTime, getTime, isYearHidden } from './formatter';
export const getFormattedStartDate = (event, fullLocale, forceShowYear = false) => {
    if (isDateTbd(event)) {
        return getScheduleTbdMessage(event);
    }
    const startDate = getStartDate(event);
    const timeZoneId = getEventTimeZoneId(event);
    const showTimeZone = getShowTimeZone(event);
    const showYear = forceShowYear || !isYearHidden(getMomentDate(startDate, timeZoneId));
    return getFullDate(startDate, timeZoneId, showYear, fullLocale, showTimeZone);
};
export const getFormattedShortStartDate = (event, fullLocale) => {
    if (isDateTbd(event)) {
        return getScheduleTbdMessage(event);
    }
    const startDate = getStartDate(event);
    const timeZoneId = getEventTimeZoneId(event);
    return getShortDate(startDate, timeZoneId, fullLocale);
};
export const getFormattedShortStartDateTime = (event, fullLocale) => {
    if (isDateTbd(event)) {
        return getScheduleTbdMessage(event);
    }
    const startDate = getStartDate(event);
    const timeZoneId = getEventTimeZoneId(event);
    return getShortDateTime(startDate, timeZoneId, fullLocale);
};
export const getFormattedStartTime = (event, fullLocale) => {
    const startDate = getStartDate(event);
    const timeZoneId = getEventTimeZoneId(event);
    return getTime(startDate, timeZoneId, fullLocale);
};
export const getFormattedFullDate = (event, fullLocale, showYear = false) => {
    if (isDateTbd(event)) {
        return getScheduleTbdMessage(event);
    }
    const endDateHidden = isEndDateHidden(event);
    const startDate = getStartDate(event);
    const endDate = getEndDate(event);
    const timeZoneId = getEventTimeZoneId(event);
    const showTimeZone = getShowTimeZone(event);
    return formatDates(startDate, endDateHidden ? null : endDate, timeZoneId, showYear, fullLocale, showTimeZone);
};
export const getDaysToEvent = (event) => {
    let days = 0;
    const HOURS_PER_DAY = 24;
    if (!isDateTbd(event)) {
        const startDate = getStartDate(event);
        const timeZoneId = getEventTimeZoneId(event);
        const start = getMomentDate(startDate, timeZoneId);
        const hours = getDurationInHours(start, now(timeZoneId));
        days = Math.ceil((hours - start.hour()) / HOURS_PER_DAY);
    }
    return Math.max(days, 0);
};
export const getFormattedOpeningClosureDate = (date, fullLocale, showTimeZone, timeZoneId, forceShowYear = false) => {
    const showYear = forceShowYear || !isYearHidden(getMomentDate(date, timeZoneId));
    return getFullDate(date, timeZoneId, showYear, fullLocale, showTimeZone);
};
export const isHappeningToday = (event) => {
    if (isScheduled(event)) {
        if (!isDateTbd(event)) {
            const startDate = getStartDate(event);
            const timeZoneId = getEventTimeZoneId(event);
            const start = getMomentDate(startDate, timeZoneId);
            const currentTime = now(timeZoneId);
            if (start.isSame(currentTime, 'date')) {
                return true;
            }
        }
    }
    return isStarted(event);
};
//# sourceMappingURL=event-selectors.js.map